<template>
  <v-container grid-list-xl fluid>

  <v-layout row wrap>
    <v-flex sm8>
      <user-form></user-form>
    </v-flex>

    <v-flex sm4>
      <change-password></change-password>
    </v-flex>
    <v-flex sm4>

    </v-flex>
  </v-layout>





  </v-container>
</template>


<script>

import axios from 'axios';
import Confirm from '@/components/app/confirm';
import ChangePassword from '@/components/app/account/changePassword';
import UserForm from '@/components/app/account/userForm';
export default {
  components: {
    ChangePassword,
    UserForm
  },
  data: () => ({
    user : {
      rut : null,
      name : null,
      surname1 : null,
      surname2 : null,
    },
  }),

  watch: {

  },
  mounted () {

  },
  methods: {

  }

};


</script>
